import useApiController from "@hooks/useApiController"

export default function useSalonLimitController(salonId: string | number): Admin.Controllers.SalonLimit {
    const { store } = useApiController(`/api/admin/salons/${salonId}/limits`)
    return { store }
}